import { TrackedOverflowList } from "./TrackedOverflowList";

// Use the tracked version as our default implementation
const OverflowList = TrackedOverflowList;

// Export all the subcomponents with the same names for backward compatibility
export const Box = OverflowList.Box;
export const List = OverflowList.List;
export const HiddenCount = OverflowList.HiddenCount;
export const HiddenElements = OverflowList.HiddenElements;
export const HiddenWrapper = OverflowList.HiddenWrapper;
export const Description = OverflowList.Description;
export const Content = OverflowList.Content;
export const Layout = OverflowList.Layout;

// Named export
export { OverflowList };

// Default export for backward compatibility
export default OverflowList;
